import { Injectable } from '@angular/core';
import { RouteService, StorageService } from '../services';
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SetupResolver {

  constructor(public storageService: StorageService, private routeService: RouteService, private activatedRoute: ActivatedRoute) {}
  
  async resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot) {
    this.storageService.setRouteName('services');
    // const setups = await this.routeService.getRouteSetups(route.queryParams['routeId']);
    // return setups;
    // // this.activatedRoute.queryParamMap.subscribe(async (params) => {
    // //   const routeId = params.get('routeId');
    // //   const setups = await this.routeService.getRouteSetups(Number(routeId));
    // //   return setups;
    // // });
  }
  
}
